import { useEffect, useRef } from 'react';
import { logger } from '@monofront/logging';
import { isEqual } from 'radash';

/**
 * This hook logs a warning if a value is identical to the previous render but has a different reference, which indicates it could have been memoized to prevent unnecessary renders.
 */
export const useMemoizableWatcher = (
  value: unknown,
  friendlyLogName: string,
) => {
  const previousValue = useRef<unknown | null>(null);

  useEffect(() => {
    if (
      // `typeof [] === 'object'`
      typeof previousValue.current === 'object' &&
      typeof value === 'object' &&
      isEqual(value, previousValue.current)
    ) {
      logger.warn(
        `${friendlyLogName}: Value is identical to previous render but is not memoized.`,
      );
    }

    previousValue.current = value;
  }, [value]);
};
